module.exports = __webpack_public_path__ + "img/ajuan_ijin.4a5c7599.png";